import { api } from "./api";

export const uploadImage = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/admin/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
};
